import httpClient from "@/services/httpClient";
import { server, trademark_const } from "@/services/constants";

export const getAllAppointmentDoctypeActionsBYID = (query) => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.APPOINTMENT_ACTION, query);
};

export const createAppointmentDoctypeActions = (data) => {
    return httpClient.post(`${trademark_const.trademark_url}/` + server.APPOINTMENT_ACTION, data);
};

export const updateAppointmentDoctypeActions = (data) => {
    return httpClient.put(`${trademark_const.trademark_url}/` + server.APPOINTMENT_ACTION + `/update`, data);
};
export const updateAppointmentData = (id, data) => {
    return httpClient.put(`${trademark_const.trademark_url}/` + server.APPOINTMENT_ACTION + `/update-appointment-data/${id}`, data);
};
export const deleteAppointmentDoctypeActions = (id) => {
    return httpClient.delete(`${trademark_const.trademark_url}/` + server.APPOINTMENT_ACTION + `/delete/${id}`);
};
export const deleteAppointmentDoctypeActionsByID = (query) => {
    return httpClient.delete(`${trademark_const.trademark_url}/` + server.APPOINTMENT_ACTION + `/by-id`, query);
};
